function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.18757 6.90794C9.17054 5.26122 10.5829 4.47142 10.6461 4.43152C9.8523 3.31459 8.61564 3.16133 8.1755 3.14389C7.1239 3.0411 6.12255 3.74001 5.58906 3.74001C5.05667 3.74001 4.23241 3.15895 3.36038 3.17375C2.21323 3.19013 1.15586 3.81584 0.565533 4.80409C-0.625825 6.793 0.260761 9.74056 1.42164 11.3548C1.98918 12.1438 2.66599 13.0316 3.55395 12.9991C4.40978 12.9666 4.73268 12.4664 5.76725 12.4664C6.80183 12.4664 7.09233 12.9991 7.99758 12.9825C8.91794 12.9664 9.5014 12.1784 10.0643 11.3862C10.7158 10.4696 10.9841 9.58202 11 9.5371C10.98 9.52812 9.20596 8.87413 9.18757 6.90794Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.48661 2.07558C7.9575 1.52544 8.27655 0.761002 8.18978 0C7.51022 0.0264237 6.68761 0.43467 6.1997 0.984282C5.76259 1.47206 5.38039 2.24866 5.4828 2.99592C6.24089 3.05246 7.01407 2.62466 7.48661 2.07558Z",
  fill: "white"
});

var SvgAppleLogo = function SvgAppleLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 11 13",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAppleLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apple_logo.fe5ca889.svg";
export { ForwardRef as ReactComponent };